<div class="leaflet-maps"
    leaflet 
    [leafletOptions]="mapOpt"
    (leafletMapReady)="onMapReady($event)"
    #mapElem
    id="mapElem"
>
</div>

<style>
    .leaflet-maps {
        width: 100%;
        height: 100%;
    }
</style>